import { render, staticRenderFns } from "./AddModal.vue?vue&type=template&id=5802dea4&"
import script from "./AddModal.vue?vue&type=script&lang=ts&"
export * from "./AddModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports